import React from 'react';
import { WorkspaceListSidebar } from './WorkspaceListSidebar';
import type { Conversation, WorkspaceMode } from '@auw/workspace-utils';

interface WorkspaceSidebarProps {
  mode: WorkspaceMode;
  pageSidebarOpen: boolean;
  onTogglePageSidebar: () => void;
  navigationSlot?: React.ReactNode;
  contentSlot?: React.ReactNode;
  filterRecentItem?: (item: Conversation) => boolean;
}

export const WorkspaceSidebar: React.FC<WorkspaceSidebarProps> = (props) => {
  return <WorkspaceListSidebar {...props} />;
};
